import * as React from 'react';
import { PassFieldCore } from '@core-front/passfield';
import Icon from '@telia-front/icon';
import TextField from '@telia-front/textfield';
export default class PassField extends React.Component {
    render() {
        return (React.createElement(PassFieldCore, Object.assign({}, this.props, { components: {
                Icon,
                TextField,
            } })));
    }
}
